import type { AnalyticsEventPayload, CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

/* Returns a function that creates `CreateUIAnalyticsEvent` instance with prefilled Event Source and
  default attributes */
export function createAnalyticsEventFactory(
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	eventSource: string,
	defaultAttributes?: AnalyticsEventPayload,
) {
	return (payload: AnalyticsEventPayload): ReturnType<CreateUIAnalyticsEvent> => {
		const { data } = payload;
		if (!data) {
			throw new Error('payload.data should be defined');
		}

		return createAnalyticsEvent({
			...payload,
			data: {
				...data,
				source: eventSource,
				attributes: {
					...defaultAttributes,
					...data.attributes,
				},
			},
		});
	};
}
